import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button, Tabs, Tab } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { creatAmenityCategory, updateAmenityCategory } from '../../../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Category-Create.scss';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch, useSelector } from 'react-redux';
import {
  allAmenitySectionsSelector,
  allHotelsSelector,
  fetchAllAmenities,
} from '../../../../property/propertySlice';
import './Category-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import { ASSET_AMENITIES } from '../../../../../constants/AmenityConst';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import CustomMultiSelect from '../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';

const AmenityCategoryCreate = (props) => {
  const { toggleDrawer, category, hotelId, showLoader = () => {} } = props;
  const originalHotels = useSelector(allHotelsSelector);
  const dispatch = useDispatch();
  const [rawImages, setRawImages] = useState([]);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const amenitySections = useSelector(allAmenitySectionsSelector);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    sectionId: {
      value: '',
      fieldName: 'Section',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 1,
    },
  });

  useEffect(() => {
    if (category) {
      const currFields = { ...formData };
      currFields.name.value = category?.name;
      currFields.images.value = category?.images || [];
      currFields.sectionId.value = category?.sectionIds || [];
      currFields.customAttributes.value = category?.customAttributes || [];
      setFormData(currFields);
    }
  }, [category]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onNextClick = (e) => {
    e.preventDefault();
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const images = await getProcessedImages(
          rawImages,
          originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
          ASSET_AMENITIES,
          hotelId,
        );
        const payload = {
          name: formData?.name?.value,
          customAttributes: formData?.customAttributes?.value,
          images: images, // Include processed images in the payload
          sectionIds: formData?.sectionId?.value,
        };
        if (category) {
          payload.id = category?.id;
          await updateAmenityCategory(payload, hotelId, language);
          notificationManager('success', 'Category updated successfully');
        } else {
          await creatAmenityCategory(payload, hotelId, language);
          notificationManager('success', 'Category created successfully');
        }

        dispatch(fetchAllAmenities(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          category
            ? notificationManager('danger', 'Category updation failed')
            : notificationManager('danger', 'Category creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData)?.filter(([key, field]) => field?.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData?.images?.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const renderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue?.map(
      (itemData) => amenitySections?.find((section) => section?.id === itemData)?.name,
    );
    return <span>{displayName?.join(', ')}</span>;
  };
  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{category ? 'Edit Category' : 'Add Category'}</span>
          </div>
          <div className='col-md-5'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='amenities-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <div className='row px-3 w-100 mt-4'>
              <div className='col-md-6'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomMultiSelect
                  item={formData?.sectionId}
                  options={amenitySections?.map((section) => ({
                    id: section?.id,
                    name: section?.name,
                  }))}
                  hideNullOption={amenitySections?.length}
                  handleInputChange={(e) => {
                    setFormData({ sectionId: e });
                  }}
                  labelField='name'
                  valueField='id'
                  isCustomDisplay={true}
                  renderCustomDisplay={renderCustomDisplay}
                />
              </div>
            </div>
            <div className='row px-3 w-100 d-flex mt-3'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
            </div>
            <div>
              <KeyValuePairList
                item={formData?.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <div className='col-md-12 mb-3'>
              <ImageUpload
                uploadedImages={formData.images.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                enabledMediaTabs={['image']}
              />
            </div>
          </div>
        )}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={(e) => onNextClick(e)}
                size='large'
                className='me-3'
                disabled={isTabInValid}
              >
                Next
              </Button>
            ) : (
              <Button
                variant='contained'
                type='submit'
                color='primary'
                className='me-3'
                size='large'
                disabled={loading}
                onClick={(e) => handleSubmit(e)}
              >
                {category ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AmenityCategoryCreate;
